import { render, staticRenderFns } from "./SaleVatRegimeSelect.vue?vue&type=template&id=0f93dd80&scoped=true"
import script from "./SaleVatRegimeSelect.vue?vue&type=script&lang=ts"
export * from "./SaleVatRegimeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f93dd80",
  null
  
)

export default component.exports